import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Dashboard.css";
import { getSetting } from "../../actions/Utils";
import User from "../user/User";
import Role from "../role/Role";
import PremiumPayment from "../PremiumPayment/PremiumPayment";
import Profile from "../profile/Profile";
import Permission from "../permission/Permission";
import DashboardHome from "../DashboardHome/DashboardHome";
import DashboardCustomer from "../DashboardCustomer/DashboardCustomer";
import { useTranslation } from 'react-i18next';
import LangData from '../common/LangData';

import CustomerPolicyList from "../CustomerPolicyList/CustomerPolicyList";
import PolicyList from "../CustomerPolicyList/PolicyList";
import CustomerDetails from "../CustomerDetails/CustomerDetails";
import AgencyDetails from "../AgencyDetails/AgencyDetails";
import CommissionDetails from "../CommissionDetails/CommissionDetails";
import PremiumHistory from "../PremiumHistory/PremiumHistory";
import CustomerProfile from "../profile/CustomerProfile";
import MyPolicies from "../MyPolicies/MyPolicies";
import MyApplications from "../MyApplications/MyApplications";
import BranchBusiness from "../BranchBusiness/BranchBusiness";
import FABusiness from "../BranchBusiness/FABusiness";
import BMBusiness from "../BranchBusiness/BMBusiness";
import UMBusiness from "../BranchBusiness/UMBusiness";
import MDBBusiness from "../BranchBusiness/MDBBusiness";
import PBLBusiness from "../BranchBusiness/PBLBusiness";
import MyBusinessDetails from "../BranchBusiness/MyBusinessDetails";
import MyAgentsBusiness from "../BranchBusiness/MyAgentsBusiness";
import ServiceRequestList from "./ServiceRequestList";
import RaiseRequest from "./RaiseRequest";
import { FaHome, FaUsers, FaList, FaCartPlus, FaUserCircle, FaBriefcase, FaQuestionCircle, FaClipboardList, FaFileAlt } from "react-icons/fa";
import { BiBorderRadius } from "react-icons/bi";
import { VscSettings } from "react-icons/vsc";
import { CgProfile } from "react-icons/cg";
import { LuShieldPlus } from "react-icons/lu";
import { Link, useHistory } from "react-router-dom";
import { permissionMap } from "../../utils/utils";
import PremiumCalculator from "../../layout/PremiumCalculator";
import PolicySubmitByDocumentUpload from "./PolicySubmitByDocumentUpload";

const DashboardDemo = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const user = useSelector((state) => state?.user);
  const userType = user?.loginuser?.user_type;
  const userId = user?.loginuser?.id;
  const roleId = Number(user?.loginuser?.role_id);
  // Customer Details: only Agent (4) and LIC Employee (2) — no Admin/Super Admin
  const isAdmin = roleId === 1;
  const canSeeCustomerDetails = roleId === 5 || roleId === 4 || roleId === 2;
  const canSeeAgencyAndCommission = roleId === 2 || roleId === 4;

  const [isSideBarOpen, setisSideBarOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const [activeItem, setActiveItem] = useState(() => {
    const savedItem = localStorage.getItem("activeItem");
    if (savedItem) {
      return savedItem;
    }
    // return userType === "Customer" ? "DashboardCustomer" : "Dashboard";
    return "Dashboard";
  });

  // Define permission-to-module mapping
  const allowedModules = new Set(
    user?.loginData?.map((p) => permissionMap[p.permission_id])
  );

  let menuItems = [
    { name: "Dashboard", icon: <FaHome className="icon-size" />, translationKey: "label_dashboard" },
    { name: "My Applications", icon: <FaFileAlt className="icon-size" />, translationKey: "label_my_applications" },
    { name: "User", icon: <FaUsers className="icon-size" />, translationKey: "label_user" },
    { name: "Role", icon: <BiBorderRadius className="icon-size" />, translationKey: "label_role" },
    { name: "Permission", icon: <VscSettings className="icon-size" />, translationKey: "label_permission" },
    { name: "Profile", icon: <CgProfile className="icon-size" />, translationKey: "label_profile" },
    { name: "Raise Request", icon: <FaQuestionCircle className="icon-size" />, translationKey: "label_raise_request" },
    { name: "Request List", icon: <FaClipboardList className="icon-size" />, translationKey: "label_request_list" },
  ];

  console.log("userType user 333333333333333333333", userType, user);

  if (userType === "Customer" || roleId === 5) {
    menuItems = [
      { name: "Dashboard", icon: <FaHome size={20} />, translationKey: "label_dashboard" },
      { name: "My Applications", icon: <FaFileAlt size={20} />, translationKey: "label_my_applications" },
      { name: "Profile", icon: <CgProfile size={20} />, translationKey: "label_profile" },
      { name: "Policy Application", icon: <FaCartPlus size={20} />, translationKey: "label_policy_application" },
      { name: "Policy Submit by Document Upload", icon: <FaFileAlt size={20} />, translationKey: "policy_submit_doc_upload" },
      { name: "Customer Details", icon: <FaUserCircle size={20} />, translationKey: "customer_details" },
      { name: "Raise Request", icon: <FaQuestionCircle size={20} />, translationKey: "label_raise_request" },
    ];
  } else {
    menuItems.push({
      name: "Policy Application",
      icon: <FaCartPlus size={20} />,
      translationKey: "label_policy_application",
    });
    menuItems.push({
      name: "Policy Submit by Document Upload",
      icon: <FaFileAlt size={20} />,
      translationKey: "policy_submit_doc_upload",
    });
  }

  if (roleId === 2 || roleId === 6 || roleId === 7 || roleId === 8 || roleId === 9) {
    if (roleId === 2) {
      menuItems.push({
        name: "My Policies",
        icon: <FaBriefcase size={20} />,
        translationKey: "label_my_policies",
      });

      menuItems.push({
        name: "Business Details",
        icon: <FaList size={20} />,
        translationKey: "business_details",
        subMenu: [
          {
            name: "Branch",
            icon: <FaBriefcase size={20} />,
            translationKey: "branch_business",
          },
          {
            name: "FA",
            icon: <FaBriefcase size={20} />,
            translationKey: "fa_business",
          },
          {
            name: "BM",
            icon: <FaBriefcase size={20} />,
            translationKey: "bm_business",
          },
          {
            name: "UM",
            icon: <FaBriefcase size={20} />,
            translationKey: "um_business",
          },
          {
            name: "Midland Bank",
            icon: <FaBriefcase size={20} />,
            translationKey: "mdb_business",
          },
          {
            name: "Premier Bank",
            icon: <FaBriefcase size={20} />,
            translationKey: "pbl_business",
          }
        ]
      });
    } else if (roleId === 8 || roleId === 9) {
      menuItems.push({
        name: "Business Details",
        icon: <FaList size={20} />,
        translationKey: "business_details",
        subMenu: [
          {
            name: "Branch",
            icon: <FaBriefcase size={20} />,
            translationKey: "branch_business",
          }
        ]
      });
    } else if (roleId === 6 || roleId === 7) {
      const subMenu = [
        {
          name: "My Details",
          icon: <FaBriefcase size={20} />,
          translationKey: "my_business_details",
        },
        {
          name: "My Agents",
          icon: <FaBriefcase size={20} />,
          translationKey: "my_agents_business",
        }
      ];

      // Role 6 (Branch Manager) can also see UM Business
      if (roleId === 6) {
        subMenu.push({
          name: "UM",
          icon: <FaBriefcase size={20} />,
          translationKey: "um_business",
        });
      }

      menuItems.push({
        name: "Business Details",
        icon: <FaList size={20} />,
        translationKey: "business_details",
        subMenu: subMenu
      });
    }
  }

  if (canSeeCustomerDetails || canSeeAgencyAndCommission) {
    menuItems.push({
      name: "Commission Details",
      icon: <FaUserCircle size={20} />,
      translationKey: "commission_details",
    });

    if (canSeeAgencyAndCommission) {
      menuItems.push({
        name: "Agency Details",
        icon: <FaUserCircle size={20} />,
        translationKey: "agency_details",
      });
    }

    if (canSeeCustomerDetails) {
      if (!menuItems.some(item => item.name === "Customer Details")) {
        menuItems.push({
          name: "Customer Details",
          icon: <FaUserCircle size={20} />,
          translationKey: "customer_details",
        });
      }

      menuItems.push({
        name: "Premium History",
        icon: <FaUserCircle size={20} />,
        translationKey: "premium_history",
      });
    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isSideBarOpen &&
        !event.target.closest(".sidebar") &&
        !event.target.closest(".navbar-toggler")
      ) {
        setisSideBarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isSideBarOpen]);

  const handleMenuClick = (item, e) => {
    e.preventDefault();
    if (item.name === "Policy Application" || item.name === "Policy Submit by Document Upload") {
      setActiveItem(item.name);
      localStorage.setItem("activeItem", item.name);
      return;
    }
    if (item.subMenu) {
      setOpenSubMenu(openSubMenu === item.name ? null : item.name);
    } else {
      setActiveItem(item.name);
      setOpenSubMenu(null);
      localStorage.setItem("activeItem", item.name);
      setisSideBarOpen(false);
    }
  };

  const handleSubMenuClick = (sub, e) => {
    e.preventDefault();
    if (sub?.name === "Policy Application" || sub?.name === "Policy Submit by Document Upload") {
      setActiveItem(sub.name);
      localStorage.setItem("activeItem", sub.name);
      return;
    }
    setActiveItem(sub.name);
    localStorage.setItem("activeItem", sub.name);
    setisSideBarOpen(false);
  };

  useEffect(() => {
    dispatch(getSetting());
  }, [dispatch]);

  useEffect(() => {
    const savedItem = localStorage.getItem("activeItem");
    if (savedItem) {
      setActiveItem(savedItem);
    }
  }, []);

  useEffect(() => {
    // Auto-expand "Business Details" if a business submenu item is active
    const businessSubItems = [
      "Branch", "FA", "BM", "UM",
      "Midland Bank", "Premier Bank",
      "My Details", "My Agents"
    ];
    if (businessSubItems.includes(activeItem)) {
      setOpenSubMenu("Business Details");
    }
  }, [activeItem]);



  return (
    <Fragment>
      <main role="main_dashboard">
        <button
          className="navbar-toggler d-md-none"
          type="button"
          onClick={() => setisSideBarOpen(!isSideBarOpen)}
          aria-label="Toggle navigation"
        >
          <span className="navbar-togglerIcon">
            <i
              className={isSideBarOpen ? "fa fa-times fa-2x" : "fa fa-bars fa-2x"}
            // style={{ marginTop: "6px" }} 
            ></i>
          </span>
        </button>

        <article className="dashboard-container d-flex">
          <aside>
            <nav className={`sidebar bg-sidebar ${isSideBarOpen ? "show" : ""}`}>
              <ul className="list-unstyled mt-3">
                {menuItems
                  .filter((item) =>
                    userType === "Customer"
                      ? true
                      : item.name === "Dashboard"
                      || item.name === "My Applications"
                      || item.name === "Profile"
                      || ((item.name === "User" || item.name === "Role" || item.name === "Permission") && isAdmin)
                      || ((item.name === "Customer Details" || item.name === "Premium History") && canSeeCustomerDetails)
                      || (item.name === "My Policies" && roleId === 2)
                      || (item.name === "Business Details" && (roleId === 2 || roleId === 6 || roleId === 7 || roleId === 8 || roleId === 9))
                      || ((item.name === "Agency Details" || item.name === "Commission Details") && canSeeAgencyAndCommission)
                      || (item.name === "Policy Application")
                      || (item.name === "Policy Submit by Document Upload")
                      || (item.name === "Raise Request" && roleId !== 8 && roleId !== 9)
                      || (item.name === "Request List" && isAdmin)
                  )
                  .map((menu) => (
                    <li key={menu.name} className={activeItem === menu.name ? "active" : ""}>
                      <div className="menu-item" onClick={(e) => handleMenuClick(menu, e)}>
                        <div>
                          <Link to="#" className="menu-text mb-0 icon_size_area" style={{ textDecoration: "none" }}>
                            <span className="mr-2">{menu.icon}</span>
                            <LangData keyname={menu.translationKey} />
                          </Link>
                        </div>
                        {menu.subMenu && <h3 className={`arrow ${openSubMenu === menu.name ? "up" : "down"} mr-3`}>↓</h3>}
                      </div>

                      {menu.subMenu && openSubMenu === menu.name && (
                        <ul className="submenu">
                          {menu.subMenu.map((sub) => (
                            <li key={sub.name} className={activeItem === sub.name ? "active" : ""}>
                              <Link
                                to="#"
                                onClick={(e) => handleSubMenuClick(sub, e)}
                                className="icon_size_area d-flex py-2 menu-text"
                                style={{ textDecoration: "none" }}
                              >
                                <span className="mr-2">{sub.icon}</span>
                                <span><LangData keyname={sub.translationKey} /></span>
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
              </ul>
            </nav>
          </aside>
          <article className="content container-fluid">
            <section>
              {activeItem === "Dashboard" && userType !== "Customer" && (
                <DashboardHome setActiveItem={setActiveItem} />
              )}
              {activeItem === "Dashboard" && userType === "Customer" && (
                <DashboardCustomer setActiveItem={setActiveItem} />
              )}
              {activeItem === "User" && <User />}
              {activeItem === "Role" && <Role />}
              {activeItem === "Premium Payment" && <PremiumPayment />}
              {activeItem === "Profile" && userType !== "Customer" && (
                <Profile />
              )}
              {activeItem === "Profile" && userType === "Customer" && (
                <CustomerProfile />
              )}
              {activeItem === "Permission" && <Permission />}
              {activeItem === "Policy List" && userType !== "Customer" && (
                <PolicyList />
              )}
              {activeItem === "Policy List" && userType === "Customer" && (
                <CustomerPolicyList />
              )}
              {activeItem === "Customer Details" && <CustomerDetails />}
              {activeItem === "Agency Details" && <AgencyDetails />}
              {activeItem === "Commission Details" && <CommissionDetails />}
              {activeItem === "Premium History" && <PremiumHistory />}
              {activeItem === "My Policies" && <MyPolicies />}
              {activeItem === "My Applications" && <MyApplications />}
              {activeItem === "Branch" && <BranchBusiness />}
              {activeItem === "FA" && <FABusiness />}
              {activeItem === "BM" && <BMBusiness />}
              {activeItem === "UM" && <UMBusiness />}
              {activeItem === "Midland Bank" && <MDBBusiness />}
              {activeItem === "Premier Bank" && <PBLBusiness />}
              {activeItem === "My Details" && <MyBusinessDetails />}
              {activeItem === "My Agents" && <MyAgentsBusiness />}
              {activeItem === "Policy Application" && <PremiumCalculator slug="/premium-calculator" />}
              {activeItem === "Policy Submit by Document Upload" && <PolicySubmitByDocumentUpload />}
              {activeItem === "Raise Request" && <RaiseRequest />}
              {activeItem === "Request List" && <ServiceRequestList />}
            </section>
          </article>
        </article>
      </main>
    </Fragment>
  );
};

export default DashboardDemo;
